module.exports = __webpack_public_path__ + "files/a62a66358033bf31a2a574dddec5c7e9.png";